import { OidcClient } from 'oidc-client-ts';
import { UserRole } from '@/utils/userType';
import { router } from '@/router';
import i18n from '@/utils/i18n/i18n';
import { toast } from 'react-toastify';
import cache from 'lscache';

import { userManager } from './UserManager';
import { AUTHENTICATION_STORAGE_KEY } from './auth.constants';

export const getSigninUrl = async () => {
  const oidcSettings = userManager.getUser().settings;
  const client = new OidcClient(oidcSettings);
  const request = await client.createSigninRequest({});

  return request.url;
};

export const getUserRole = (roles: string[]): UserRole => {
  const ilinkRoles = roles.find(role => role.includes('id=Ilink'));

  if (ilinkRoles?.includes(`id=${UserRole.ADMIN}`)) {
    return UserRole.ADMIN;
  }
  if (ilinkRoles?.includes(`id=${UserRole.SPORTCONTRIBUTOR}`)) {
    return UserRole.SPORTCONTRIBUTOR;
  }
  if (ilinkRoles?.includes(`id=${UserRole.COUNTRYCONTRIBUTOR}`)) {
    return UserRole.COUNTRYCONTRIBUTOR;
  }

  return UserRole.UNAUTHORIZED;
};

export const handleSessionExpiration = () => {
  cache.remove(`${AUTHENTICATION_STORAGE_KEY}-token`);
  router.invalidate().catch(() => {});

  toast.error(i18n.t('error.message.token.expired'), {
    autoClose: 3000,
  });
};
